export const calendar = {
  title: "Kalender",
  subtitle: "Buchungen Ihrer Unterkünfte verwalten",
  createBooking: "Buchung erstellen",
  propertyLabel: "Unterkunft",
  searchPlaceholder: "Unterkunft suchen",
  filterByProperty: "Unterkünfte filtern",
  clearFilters: "Filter zurücksetzen",
  loadingMore: "Weitere Tage werden geladen…",

  payment: {
    "pending":  "Zahlung ausstehend",
    "paid":     "Bezahlt",
    "rejected": "Zahlung abgelehnt",
    "refunded": "Erstattet",
    "partial":  "Teilzahlung"
  },

  tooltips: {
    noChannels: "Mit keinem Kanal verbunden",
    connectedTo: "Verbunden mit: {channels}",
    manual: "WA Checkin (manuell)",
    other: "Anderer Kanal",
    configPrices: "Preise konfigurieren",
  },

  errors: {
    loadCalendar: "Fehler beim Laden der Kalenderdaten",
    updateViewAfterCancel: "Fehler beim Aktualisieren der Ansicht nach der Stornierung",
    closeDates: "Fehler beim Sperren der Tage",
    deleteClosedDates: "Fehler beim Löschen der gesperrten Tage",
    updateClosedDates: "Fehler beim Aktualisieren der gesperrten Tage",
  },

  filters: {
    showPrices: "Preise anzeigen",
    today: "Heute",
    multi: "Mehrere",
    monthly: "Monatlich",
    prevMonthAria: "Vorheriger Monat",
    nextMonthAria: "Nächster Monat",
  },

  actions: {
    title: "Aktion auswählen",
    question: "Was möchten Sie mit den ausgewählten Tagen tun?",
    createBooking: "Buchung erstellen",
    blockDates: "Tag sperren",
    editNightPrice: "Preis pro Nacht bearbeiten",
    editMinStay: "Mindestaufenthalt",
    editMinStayHint: "Mindestanzahl an Nächten pro Tag festlegen",
  },
  minStayModal: {
    description:
      "Legen Sie den Mindestaufenthalt für den ausgewählten Zeitraum fest. Bestehende Preise sind davon nicht betroffen.",
    success: "Mindestaufenthalt erfolgreich aktualisiert",
    hint: "Mindestanzahl an Nächten, die der Gast buchen muss.",
    errors: {
      minOne: "Der Mindestaufenthalt muss mindestens 1 Nacht betragen.",
    },
  },

  fields: {
    startDate: "Startdatum",
    endDate: "Enddatum",
  },

  buttons: {
    delete: "Löschen",
    cancel: "Abbrechen",
    save: "Speichern",
    close: "Schließen",
    saveChanges: "Änderungen speichern",
    closeDates: "Tage sperren",
  },

  closeModal: {
    headerCreate: "TAGE SPERREN",
    headerEdit: "GESPERRTE TAGE BEARBEITEN",
  },

  priceModal: {
    description:
      "Dies ist eine manuelle Änderung des ausgewählten Preises. Alles, was Sie hier ändern, betrifft nur diese Unterkunft und diesen Zeitraum.",
    periodLabel: "Zeitraum",
    startPlaceholder: "Startdatum",
    endPlaceholder: "Enddatum",
    pricePerNight: "Preis pro Nacht",
    minStay: "Mindestaufenthalt",
    minNightsPlaceholder: "Mindestnächte",
    pricePlaceholder: "Preis für den ausgewählten Zeitraum",
    success: "Preise erfolgreich aktualisiert",
    errors: {
      invalidRange: "Sie müssen einen gültigen Zeitraum auswählen",
      startAfterEnd: "Das Startdatum darf nicht nach dem Enddatum liegen",
      minStay:
        "Der Mindestaufenthalt beträgt {min} Nächte, der ausgewählte Zeitraum hat aber {nights} Nächte",
      missingSelection: "Es wurde keine Unterkunft und kein Zeitraum ausgewählt",
      request: "Fehler bei der Anfrage: {msg}",
      update: "Fehler beim Aktualisieren der Preise: {msg}",
    },
  },

  details: {
    header: "Buchungsdetails",
    title: "Buchung",
    createdOn: "Erstellt am {date}",
    checkIn: "Check-in",
    checkOut: "Check-out",
    arrow: "→",
    statusLabel: "Status",
    status: {
      booked: "Gebucht",
      blocked: "Gesperrt",
    },
    night_one: "Nacht",
    night_other: "Nächte",
    actions: {
      view: "Buchung ansehen",
      changeRoom: "Zimmer wechseln",
      cancel: "Buchung stornieren",
    },
  },
};

export default calendar;
